export const DEFAULT_AB_TESTS = {};
